<form
  [formGroup]="form"
  (ngSubmit)="confirm()"
  class="flex flex-col">
  <div class="flex flex-col">
    <div
      id="header"
      class="flex w-full justify-between mt-6 border-b border-neutral-300 sticky top-0 bg-white py-4 z-50">
      <h1 class="text-[18px] font-black">
        <i
          class="pi pi-file-plus"
          style="font-size: 2rem"></i>
        USO DE SOLUCIÓN IA — FASE 2
      </h1>

      <div
        id="buttons"
        class="flex gap-4">
        <app-buttons
          [label]="'Cancelar'"
          (click)="backPage()" />
        <app-buttons
          [label]="'Guardar'"
          [disabled]="form.invalid"
          [classes]="'bg-primary-base text-primary-light'"
          (click)="confirm()"
          type="button" />
      </div>
    </div>

    <div class="flex flex-col py-4 gap-2">
      <span class="text-2xl font-bold">Registro de Herramienta / Agente de IA</span>
      <span class="text-[16px] text-neutral-dark py-1">
        Todos los campos marcados con un asterisco (*) son obligatorios.
      </span>
    </div>

    <div class="flex flex-col gap-6 py-4">
      <span class="text-[18px] font-bold">Datos identificativos</span>

      <div class="grid grid-cols-1 md:grid-cols-2 gap-4">
        <div class="flex flex-col">
          <label
            class="text-[16px]"
            for="solution-usage-name">
            Identificador del registro*
          </label>
          <desy-input
            id="solution-usage-name"
            classes="w-full"
            formControlName="solutionUsageName"></desy-input>
          <desy-error-message *ngIf="getError(form, 'solutionUsageName', formSubmitted()) as error">
            {{ error }}
          </desy-error-message>
        </div>

        <div class="flex flex-col">
          <label
            class="text-[16px]"
            for="solution-name">
            Nombre de la solución IA*
          </label>
          <desy-input
            id="solution-name"
            classes="w-full"
            formControlName="solutionName"></desy-input>
          <desy-error-message *ngIf="getError(form, 'solutionName', formSubmitted()) as error">
            {{ error }}
          </desy-error-message>
        </div>

        <div class="flex flex-col">
          <label
            class="text-[16px]"
            for="ai-solution-subtype">
            Subtipo de solución IA*
          </label>
          <desy-select
            id="ai-solution-subtype"
            formControlName="aiSolutionSubtype"
            classes="min-w-full mt-2">
            <desy-option
              value=""
              [disabled]="true"
              [hidden]="true"
              [selected]="true">
              Selecciona un subtipo
            </desy-option>
            <desy-option
              *ngFor="let option of aiSolutionSubtypeOptions"
              [id]="option.value"
              [value]="option.value">
              {{ option.label }}
            </desy-option>
          </desy-select>
          <desy-error-message *ngIf="getError(form, 'aiSolutionSubtype', formSubmitted()) as error">
            {{ error }}
          </desy-error-message>
        </div>

        <div class="flex flex-col">
          <label
            class="text-[16px]"
            for="platform-or-provider">
            Plataforma o proveedor*
          </label>
          <desy-input
            id="platform-or-provider"
            classes="w-full"
            placeholder="Ej. Microsoft, OpenAI, etc."
            formControlName="platformOrProvider"></desy-input>
          <desy-error-message *ngIf="getError(form, 'platformOrProvider', formSubmitted()) as error">
            {{ error }}
          </desy-error-message>
        </div>

        <div class="flex flex-col">
          <label
            class="text-[16px]"
            for="version">
            Versión*
          </label>
          <desy-input
            id="version"
            classes="w-full"
            type="text"
            inputmode="numeric"
            placeholder="Ej. 1, 2, etc."
            (beforeinput)="preventInvalidVersionInput($event)"
            (paste)="preventInvalidVersionInput($event)"
            formControlName="version"></desy-input>
          <desy-error-message *ngIf="getError(form, 'version', formSubmitted()) as error">
            {{ error }}
          </desy-error-message>
        </div>

        <!-- <div class="flex flex-col">
          <label
            class="text-[16px]"
            for="solution-status">
            Estado de la solución*
          </label>
          <desy-select
            id="solution-status"
            formControlName="solutionStatus"
            classes="min-w-full mt-2">
            <desy-option
              value=""
              [disabled]="true"
              [hidden]="true"
              [selected]="true">
              Selecciona un estado
            </desy-option>
            <desy-option
              *ngFor="let option of solutionStatusOptions"
              [id]="option.value"
              [value]="option.value">
              {{ option.label }}
            </desy-option>
          </desy-select>
          <desy-error-message *ngIf="getError(form, 'solutionStatus', formSubmitted()) as error">
            {{ error }}
          </desy-error-message>
        </div> -->

        <div class="flex flex-col mt-1">
          <label
            class="text-[16px]"
            for="registration-date">
            Fecha de registro*
          </label>
          <app-date-picker
            id="registration-date"
            class="w-full flex-1"
            [inline]="false"
            [placeholder]="'Seleccione una fecha'"
            formControlName="registrationDate" />
          <desy-error-message
            *ngIf="getError(form, 'registrationDate', formSubmitted()) as error"
            class="registration-date-error">
            {{ error }}
          </desy-error-message>
        </div>
      </div>
    </div>

    <div class="flex flex-col gap-6 py-4">
      <span class="text-[18px] font-bold">Unidad responsable</span>

      <div class="grid grid-cols-1 md:grid-cols-2 gap-4">
        <div class="flex flex-col">
          <label
            class="text-[16px]"
            for="department">
            Departamento u organismo responsable*
          </label>
          <desy-input
            id="department"
            classes="w-full"
            formControlName="department"></desy-input>
          <desy-error-message *ngIf="getError(form, 'department', formSubmitted()) as error">
            {{ error }}
          </desy-error-message>
        </div>

        <div class="flex flex-col">
          <label
            class="text-[16px]"
            for="requesting-person">
            Responsable funcional*
          </label>
          <desy-input
            id="requesting-person"
            classes="w-full"
            formControlName="requestingPerson"></desy-input>
          <desy-error-message *ngIf="getError(form, 'requestingPerson', formSubmitted()) as error">
            {{ error }}
          </desy-error-message>
        </div>

        <div class="flex flex-col">
          <label
            class="text-[16px]"
            for="requesting-person-email">
            Correo electrónico del responsable*
          </label>
          <desy-input
            id="requesting-person-email"
            classes="w-full"
            formControlName="requestingPersonEmail"></desy-input>
          <desy-error-message *ngIf="getError(form, 'requestingPersonEmail', formSubmitted()) as error">
            {{ error }}
          </desy-error-message>
        </div>

        <div class="flex flex-col">
          <label
            class="text-[16px]"
            for="scope-of-use">
            Ámbito de uso*
          </label>
          <desy-select
            id="scope-of-use"
            formControlName="scopeOfUse"
            classes="min-w-full mt-2">
            <desy-option
              value=""
              [disabled]="true"
              [hidden]="true"
              [selected]="true">
              Selecciona un ámbito de uso
            </desy-option>
            <desy-option
              *ngFor="let option of scopeOfUseOptions"
              [id]="option.value"
              [value]="option.value">
              {{ option.label }}
            </desy-option>
          </desy-select>
          <desy-error-message *ngIf="getError(form, 'scopeOfUse', formSubmitted()) as error">
            {{ error }}
          </desy-error-message>
        </div>
      </div>
    </div>

    <div class="flex flex-col gap-6 py-4">
      <span class="text-[18px] font-bold">Descripción funcional</span>

      <div class="grid grid-cols-1 md:grid-cols-2 gap-4">
        <div class="flex flex-col md:col-span-2">
          <label
            class="text-[16px]"
            for="expected-use">
            Finalidad o caso de uso*
          </label>
          <desy-textarea
            id="expected-use"
            formControlName="expectedUse"
            classes="w-full text-[16px]"
            class="w-full"
            [rows]="5"
            [maxlength]="500"></desy-textarea>
          <desy-error-message *ngIf="getError(form, 'expectedUse', formSubmitted()) as error">
            {{ error }}
          </desy-error-message>
        </div>

        <div class="flex flex-col md:col-span-2">
          <label
            class="text-[16px] mb-2"
            for="related-process">
            Procedimiento o proceso relacionado*
          </label>
          <div class="procedure-autocomplete-field">
            <p-autoComplete
              #procedureAutocomplete
              [(ngModel)]="procedureSearch"
              [ngModelOptions]="{ standalone: true }"
              [suggestions]="proceduresList"
              (completeMethod)="onSearchProcedure($event)"
              (onSelect)="onProcedureSelected($event)"
              (onFocus)="clearProcedureSearch()"
              (keydown.enter)="onProcedureSearchEnter($event, procedureAutocomplete)"
              [forceSelection]="true"
              placeholder="Buscar procedimiento"
              optionLabel="name"
              [minLength]="3"
              [dropdown]="false"
              [inputStyle]="{ width: '100%', 'padding-right': '2.75rem' }">
              <ng-template
                let-item
                pTemplate="item">
                {{ item.code }} - {{ item.name }}
              </ng-template>
              <ng-template pTemplate="loadingicon"></ng-template>
              <ng-template pTemplate="empty">
                @if (procedureSearchLoading) {
                  <div class="procedure-loading-row">
                    <span>Cargando resultados</span>
                    <i class="pi pi-spinner pi-spin"></i>
                  </div>
                } @else {
                  No se encontraron resultados
                }
              </ng-template>
            </p-autoComplete>
            <button
              type="button"
              class="procedure-search-button"
              aria-label="Buscar procedimiento"
              (mousedown)="$event.preventDefault()"
              (click)="searchCurrentProcedure(procedureAutocomplete, $event)">
              <i class="pi pi-search"></i>
            </button>
          </div>
          <div class="flex gap-2 flex-wrap mt-2">
            @for (process of relatedProcesses(); track $index) {
              <app-pill
                [value]="process.code + ' - ' + process.name"
                [classe]="'c-pill--primary'"
                [isDeletable]="true"
                (accions)="removeRelatedProcess(process.code)" />
            }
          </div>
          <desy-error-message *ngIf="getError(form, 'relatedProcess', formSubmitted()) as error">
            {{ error }}
          </desy-error-message>
        </div>

        <div class="flex flex-col col-span-1 mt-2">
          <label
            class="text-[16px]"
            for="related-applications-or-systems">
            Aplicaciones o sistemas relacionados*
          </label>
          <div class="flex flex-col">
            <div class="flex flex-row gap-2">
              <div class="w-full items-end">
                <desy-input
                  id="related-applications-or-systems"
                  [classes]="'w-full'"
                  [placeholder]="'Describe las aplicaciones o sistemas relacionados'"
                  [ngModel]="relatedApplicationOrSystem()"
                  (ngModelChange)="relatedApplicationOrSystem.set($event)"
                  [ngModelOptions]="{ standalone: true }"></desy-input>
              </div>
              <div class="mt-2">
                <app-buttons
                  type="button"
                  (click)="addRelatedApplicationOrSystem($event)"
                  [label]="'Añadir'"
                  [classes]="'bg-primary-base text-white'"></app-buttons>
              </div>
            </div>
          </div>
          <div class="flex gap-1 flex-wrap -mt-5">
            @for (item of relatedApplicationsOrSystems(); track item) {
              <app-pill
                [value]="item"
                [classe]="'c-pill--primary'"
                [isDeletable]="true"
                (accions)="removeRelatedApplicationOrSystem(item)" />
            }
          </div>
          <desy-error-message *ngIf="getError(form, 'relatedApplicationsOrSystems', formSubmitted()) as error">
            {{ error }}
          </desy-error-message>
        </div>

        <div class="flex flex-col mt-2">
          <label
            class="text-[16px]"
            for="enabled-actions">
            Acciones habilitadas*
          </label>
          <desy-select
            id="enabled-actions"
            formControlName="enabledActions"
            classes="min-w-full mt-2">
            <desy-option
              value=""
              [disabled]="true"
              [hidden]="true"
              [selected]="true">
              Selecciona las acciones habilitadas
            </desy-option>
            <desy-option
              *ngFor="let option of enabledActionsOptions"
              [id]="option.value"
              [value]="option.value">
              {{ option.label }}
            </desy-option>
          </desy-select>
          <desy-error-message *ngIf="getError(form, 'enabledActions', formSubmitted()) as error">
            {{ error }}
          </desy-error-message>
        </div>

        <div class="flex flex-col md:col-span-2">
          <label
            class="text-[16px]"
            for="data-sources">
            Fuentes de datos o conocimiento*
          </label>
          <desy-textarea
            id="data-sources"
            formControlName="dataSources"
            classes="w-full text-[16px]"
            class="w-full"
            [rows]="5"></desy-textarea>
          <desy-error-message *ngIf="getError(form, 'dataSources', formSubmitted()) as error">
            {{ error }}
          </desy-error-message>
        </div>

        <div class="flex flex-col">
          <label
            class="text-[16px]"
            for="autonomy-level">
            Grado de autonomía*
          </label>
          <desy-select
            id="autonomy-level"
            formControlName="autonomyLevel"
            classes="min-w-full mt-2">
            <desy-option
              value=""
              [disabled]="true"
              [hidden]="true"
              [selected]="true">
              Selecciona un nivel
            </desy-option>
            <desy-option
              *ngFor="let option of autonomyLevelOptions"
              [id]="option.value"
              [value]="option.value">
              {{ option.label }}
            </desy-option>
          </desy-select>
          <desy-error-message *ngIf="getError(form, 'autonomyLevel', formSubmitted()) as error">
            {{ error }}
          </desy-error-message>
        </div>
      </div>
    </div>

    <div class="flex flex-col gap-6 py-4">
      <span class="text-[18px] font-bold">Cumplimiento y protección de datos</span>

      <div class="grid grid-cols-1 md:grid-cols-2 gap-4">
        <div class="flex flex-col">
          <label
            class="text-[16px]"
            for="personal-data-processing">
            Tratamiento de datos personales*
          </label>
          <desy-select
            id="personal-data-processing"
            formControlName="personalDataProcessing"
            classes="min-w-full mt-2">
            <desy-option
              [disabled]="true"
              [hidden]="true"
              [selected]="true">
              Selecciona una opción
            </desy-option>
            <desy-option
              *ngFor="let option of personalDataProcessingOptions"
              [id]="option.value.toString()"
              [value]="option.value">
              {{ option.label }}
            </desy-option>
          </desy-select>
          <desy-error-message *ngIf="getError(form, 'personalDataProcessing', formSubmitted()) as error">
            {{ error }}
          </desy-error-message>
        </div>

        <div class="flex flex-col">
          <label
            class="text-[16px]"
            for="personal-data-category">
            Categoría de datos personales*
          </label>
          <desy-select
            id="personal-data-category"
            formControlName="personalDataCategory"
            classes="min-w-full mt-2">
            <desy-option
              value=""
              [disabled]="true"
              [hidden]="true"
              [selected]="true">
              Selecciona una categoría
            </desy-option>
            <desy-option
              *ngFor="let option of personalDataCategoryOptions"
              [id]="option.value"
              [value]="option.value">
              {{ option.label }}
            </desy-option>
          </desy-select>
          <desy-error-message *ngIf="getError(form, 'personalDataCategory', formSubmitted()) as error">
            {{ error }}
          </desy-error-message>
        </div>

        <div class="flex flex-col">
          <label
            class="text-[16px]"
            for="ai-act-classification">
            Clasificación AI Act*
          </label>
          <desy-select
            id="ai-act-classification"
            formControlName="aiActClassification"
            classes="min-w-full mt-2">
            <desy-option
              value=""
              [disabled]="true"
              [hidden]="true"
              [selected]="true">
              Selecciona una clasificación
            </desy-option>
            <desy-option
              *ngFor="let option of aiActClassificationOptions"
              [id]="option.value"
              [value]="option.value">
              {{ option.label }}
            </desy-option>
          </desy-select>
          <desy-error-message *ngIf="getError(form, 'aiActClassification', formSubmitted()) as error">
            {{ error }}
          </desy-error-message>
        </div>

        <div class="flex flex-col">
          <label
            class="text-[16px]"
            for="data-protection-reference">
            Referencia EIPD / RAT / Base jurídica*
          </label>
          <desy-input
            id="data-protection-reference"
            classes="w-full"
            formControlName="dataProtectionReference"></desy-input>
          <desy-error-message *ngIf="getError(form, 'dataProtectionReference', formSubmitted()) as error">
            {{ error }}
          </desy-error-message>
        </div>
      </div>
    </div>
  </div>
</form>

<p-confirmdialog />
